import {
  StatusAvailable,
  StatusAway,
  StatusBusy,
  StatusDoNotDisturb,
  StatusOffline,
} from "@/assets/icons";
import { UserStatus } from "./types";

export const getIconStatus = (status?: string) => {
  switch (status) {
    case UserStatus.Available:
    case UserStatus.AvailableIdle:
      return StatusAvailable;
    case UserStatus.Busy:
    case UserStatus.BusyIdle:
      return StatusBusy;
    case UserStatus.DoNotDisturb:
      return StatusDoNotDisturb;
    case UserStatus.Away:
    case UserStatus.BeRightBack:
      return StatusAway;
    case UserStatus.Offline:
      return StatusOffline;
    default:
      return null;
  }
};
